export const reelPaddings = [
[["H2","BL","H3","X2"],["H2","H3","BL","H2"],["H1","X3","BL","H3"],["BL","H3","BL","BL"]],
[["H1","BL","H1","H1"],["BL","BL","X3","H2"],["BL","H3","BL","H1"],["BL","X3","H2","BL"]],
[["H2","H3","BL","X2"],["H2","H1","H1","H1"],["BL","H3","BL","BN"],["BL","X3","H1","BL"]],
[["H1","BL","BL","H2"],["H1","H1","H1","H3"],["H2","BL","X3","H2"],["H2","BL","H2","BL"]]
]